import React from 'react';
import Children from '../../interfaces/children.interface';
import ClassName from '../../interfaces/class-name.interface';
import Gap from '../../interfaces/gap.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends Children, ClassName, Gap, TestId {
  /** Flag to determine whether the toggle is activated or not */
  active?: boolean;

  /** The input's id */
  id: string;

  /** Change listener */
  onChange?: () => void;
}

/** Renders a switch to toggle values */
const Toggle = ({
  active = false,
  className = '',
  gap = 'none',
  onChange = (): void => {},
  id,
  children,
  testId,
}: Props): React.ReactElement => (
  <label
    htmlFor={id}
    className={`toggle flex items-center cursor-pointer gap--${gap} ${className}`}
    data-testid={testId}
  >
    <input
      className="toggle__checkbox hidden"
      defaultChecked={active}
      id={id}
      name={id}
      onChange={onChange}
      type="checkbox"
    />
    <span className="toggle__button" />
    {children}
  </label>
);

export default Toggle;
